import { createContext, useContext } from 'react';

type StepState = {
  onBack?: () => void;
  canNext?: boolean;
  onNext?: () => void;
};

export const StepContext = createContext<StepState>({
  canNext: true,
});

export const useStepContext = () => {
  const context = useContext(StepContext);
  if (!context) {
    throw new Error('useStepContext must be used within a StepContextProvider');
  }
  return context;
};
